import { DialogContent, DialogOverlay } from "@reach/dialog";
import { isEqual } from "lodash";
import { memo, useCallback } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { showMenuState } from "../../state/home";
import "./MenuDialog.scss";
import Header from "../Header/Header";
const MenuDialog = memo(() => {
  const isModalOpen = useRecoilValue(showMenuState);
  const setIsModalOpen = useSetRecoilState(showMenuState);

  const handleCancel = useCallback(() => {
    setIsModalOpen(false);
  }, []);
  return (
    <DialogOverlay
      isOpen={isModalOpen}
      onDismiss={handleCancel}
      className="menu_dialog"
    >
      <DialogContent>
        <Header />
        <h3 className="menu_dialog_title">AI Games</h3>
        <h3 className="menu_dialog_title">AI Chain</h3>
        <h3 className="menu_dialog_title">AI Mining</h3>
        <h3 className="menu_dialog_title">Ecosystem</h3>
      </DialogContent>
    </DialogOverlay>
  );
}, isEqual);
export default MenuDialog;
